import React from 'react';
import classNames from 'classnames';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';

import Field from './Field';
import Input from './Input';
import Label from './Label';

const CheckboxField = ({
	className, name, children, value, id, onChange
}) => {

	const { getValues } = useFormContext();
	const values = getValues()[name];
	const fullClassName = classNames(className, 'fieldCheckbox');
	let checked = false;

	if (values === true) {

		checked = true;

	} else if (typeof values === 'string' || Array.isArray(values)) {

		checked = values.includes(value);

	}

	return (
		<Field className={fullClassName}>
			<Input
				name={name}
				type="checkbox"
				value={value}
				id={id}
				checked={checked}
				onChange={(e) => {

					if (typeof onChange === 'function') {

						onChange(e);

					}

				}}
			/>
			<Label htmlFor={id}>
				{children}
			</Label>
		</Field>
	);

};

CheckboxField.propTypes = {
	className: PropTypes.string,
	name: PropTypes.string.isRequired,
	children: PropTypes.oneOfType([ PropTypes.node, PropTypes.arrayOf(PropTypes.node) ]).isRequired,
	value: PropTypes.string.isRequired,
	id: PropTypes.string.isRequired,
	onChange: PropTypes.func
};

export default CheckboxField;
